(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'SearchBar',
	};

	var hotelRooms = [{
		numAdults   : 2,
		numChildren : 0,
		childrenAges: []
	}];

	function encodeUrlParam(data) {
		return btoa(JSON.stringify(data))
			.replace(/\+/g, '-')
			.replace((/\//g), '_')
			.replace((/[=]+$/), '');
	}

	function normalizeHotelDateValue($form, fieldId) {
		var $hidden  = $form.find('#' + fieldId + '_hidden'),
			$visible = $form.find('#' + fieldId),
			val, parsed;

		if ($hidden.length && $hidden.val()) {
			val = $hidden.val();
		} else if ($visible.length) {
			val = $visible.val();
		} else {
			return '';
		}

		if ((/^\d{4}-\d{2}-\d{2}$/).test(val)) {
			return val;
		}

		if (typeof moment === 'function') {
			parsed = moment(val, ['YYYY-MM-DD', 'MM/DD/YYYY', 'M/D/YYYY'], true);
			if (parsed.isValid()) {
				return parsed.format('YYYY-MM-DD');
			}
		}

		return val;
	}

	function setHotelCheckoutValue($form, dateStr) {
		var $checkOut = $form.find('#searchbar-checkout');

		$checkOut.val(dateStr);

		if ($form.find('#searchbar-checkout_hidden').length) {
			$form.find('#searchbar-checkout_hidden').val(dateStr);
		}
	}

	function updateCheckoutMinDate($form, checkInVal) {
		var $checkOut = $form.find('#searchbar-checkout'),
			checkInMoment,
			minDate;

		if (!$checkOut.length || !checkInVal) {
			return;
		}

		checkInMoment = moment(checkInVal, 'YYYY-MM-DD', true);
		if (!checkInMoment.isValid()) {
			return;
		}

		minDate = checkInMoment.clone().add(1, 'days').format('YYYY-MM-DD');
		$checkOut.attr('min', minDate);
	}

	function ensureCheckoutAfterCheckIn($form) {
		var checkInVal   = normalizeHotelDateValue($form, 'searchbar-checkin'),
			checkOutVal  = normalizeHotelDateValue($form, 'searchbar-checkout'),
			checkInMoment,
			checkOutMoment,
			nextDay;

		if (!checkInVal) {
			return;
		}

		checkInMoment = moment(checkInVal, 'YYYY-MM-DD', true);
		if (!checkInMoment.isValid()) {
			return;
		}

		updateCheckoutMinDate($form, checkInVal);

		checkOutMoment = checkOutVal ? moment(checkOutVal, 'YYYY-MM-DD', true) : null;

		if (
			!checkOutMoment ||
			!checkOutMoment.isValid() ||
			!checkOutMoment.isAfter(checkInMoment, 'day')
		) {
			nextDay = checkInMoment.clone().add(1, 'days').format('YYYY-MM-DD');
			setHotelCheckoutValue($form, nextDay);
		}
	}

	function buildChildAgeOptions(selectedAge) {
		var html = '',
			age;

		for (age = 0; age <= 17; age++) {
			html += '<option value="' + age + '"' + (parseInt(selectedAge, 10) === age ? ' selected' : '') + '>';
			html += (age === 0 ? '<1' : String(age));
			html += '</option>';
		}

		return html;
	}

	function buildRoomConfigUI() {
		var $container = $('.searchbar-hotel-room-config-container'),
			html, r, room, c;

		$container.empty();

		html = '<div class="form-group">'
			+ '<label for="searchbar-hotel-num-rooms">Number of Rooms:</label>'
			+ '<select id="searchbar-hotel-num-rooms" class="form-control searchbar-hotel-num-rooms">';

		for (r = 1; r <= 4; r++) {
			html += '<option value="' + r + '"' + (hotelRooms.length === r ? ' selected' : '') + '>' + r + '</option>';
		}

		html += '</select></div>';

		for (r = 0; r < hotelRooms.length; r++) {
			room = hotelRooms[r];
			html += '<div class="searchbar-hotel-room-block margin10-top" data-room-index="' + r + '">'
				+ '<h4>Room ' + (r + 1) + '</h4>'
				+ '<div class="form-group">'
				+ '<label>Number of Adults:</label>'
				+ '<select class="form-control searchbar-hotel-num-adults" data-room="' + r + '">';

			for (c = 1; c <= 4; c++) {
				html += '<option value="' + c + '"' + (room.numAdults === c ? ' selected' : '') + '>' + c + '</option>';
			}

			html += '</select></div>'
				+ '<div class="form-group">'
				+ '<label>Number of Children:</label>'
				+ '<select class="form-control searchbar-hotel-num-children" data-room="' + r + '">';

			for (c = 0; c <= 4; c++) {
				html += '<option value="' + c + '"' + (room.numChildren === c ? ' selected' : '') + '>' + c + '</option>';
			}

			html += '</select></div>';

			if (room.numChildren > 0) {
				for (c = 0; c < room.numChildren; c++) {
					html += '<div class="form-group">'
						+ '<label>Child Age (' + (c + 1) + '):</label>'
						+ '<select class="form-control searchbar-hotel-child-age" data-room="' + r + '" data-child="' + c + '">'
						+ buildChildAgeOptions(room.childrenAges[c] || 0)
						+ '</select></div>';
				}
			}

			html += '</div>';
		}

		$container.html(html);
	}

	function updateHotelRoomDisplay($form) {
		var totalRooms    = hotelRooms.length,
			totalAdults   = 0,
			totalChildren = 0,
			text, i;

		for (i = 0; i < hotelRooms.length; i++) {
			totalAdults   += parseInt(hotelRooms[i].numAdults, 10) || 0;
			totalChildren += parseInt(hotelRooms[i].numChildren, 10) || 0;
		}

		text = totalRooms + ' room' + (totalRooms > 1 ? 's' : '')
			+ ' / ' + totalAdults + ' adult' + (totalAdults > 1 ? 's' : '');

		if (totalChildren > 0) {
			text += ', ' + totalChildren + ' child' + (totalChildren > 1 ? 'ren' : '');
		}

		$form.find('.searchbar-hotel-room-display').val(text);
	}

	function serializeHotelRooms($form) {
		$form.find('input[name*="rooms_json"]').val(JSON.stringify(hotelRooms));
	}

	function initHotelRoomsFromForm($form) {
		var existingVal = $form.find('input[name*="rooms_json"]').val(),
			parsed;

		if (!existingVal) {
			return;
		}

		try {
			parsed = JSON.parse(existingVal);

			if (Array.isArray(parsed) && parsed.length > 0) {
				hotelRooms = parsed.map(function mapRoom(room) {
					var childAges = room.childrenAges;

					if (!Array.isArray(childAges)) {
						childAges = room.child_ages || [];
					}

					return {
						numAdults   : parseInt(room.numAdults, 10) || parseInt(room.num_adults, 10) || parseInt(room.adults, 10) || 2,
						numChildren : parseInt(room.numChildren, 10) || parseInt(room.num_children, 10) || parseInt(room.children, 10) || 0,
						childrenAges: Array.isArray(childAges) ? childAges : []
					};
				});
			}
		} catch (e) {
			hotelRooms = [{
				numAdults   : 2,
				numChildren : 0,
				childrenAges: []
			}];
		}

		updateHotelRoomDisplay($form);
		serializeHotelRooms($form);
	}

	function openNativeDatePicker(input) {
		if (!input || input.disabled) {
			return;
		}

		if (typeof input.showPicker === 'function') {
			try {
				input.showPicker();
				return;
			} catch (err) {
				// showPicker may throw if not allowed; fall through to focus
			}
		}

		input.focus();
	}

	function initHotelDatePickerIcons($form) {
		$form.find('.searchbar-hotel-date').each(function eachDateField() {
			var $input = $(this);

			$input.siblings('.input-group-addon').on('click', function onCalendarClick(e) {
				e.preventDefault();
				openNativeDatePicker($input.get(0));
			});
		});
	}

	function initHotelRoomModal($form) {
		var $modal = $('#searchbarHotelRoomModal');

		if ($modal.length && !$modal.parent().is('body')) {
			$('body').append($modal);
		}

		$modal.on('show.bs.modal', function onModalShow(e) {
			var $trigger = $(e.relatedTarget);

			if (!$trigger.length || !$trigger.is('.searchbar-hotel-room-display')) {
				e.preventDefault();
				return;
			}

			buildRoomConfigUI();
		});

		$(document).on('change', '.searchbar-hotel-num-rooms', function numRoomsChange() {
			var count = parseInt($(this).val(), 10),
				current = hotelRooms.length,
				i;

			if (count > current) {
				for (i = current; i < count; i++) {
					hotelRooms.push({
						numAdults   : 2,
						numChildren : 0,
						childrenAges: []
					});
				}
			} else if (count < current) {
				hotelRooms = hotelRooms.slice(0, count);
			}

			buildRoomConfigUI();
			updateHotelRoomDisplay($form);
			serializeHotelRooms($form);
		});

		$(document).on('change', '.searchbar-hotel-num-adults', function adultsChange() {
			var roomIdx = $(this).data('room');

			hotelRooms[roomIdx].numAdults = parseInt($(this).val(), 10);
			updateHotelRoomDisplay($form);
			serializeHotelRooms($form);
		});

		$(document).on('change', '.searchbar-hotel-num-children', function childrenChange() {
			var roomIdx    = $(this).data('room'),
				childCount = parseInt($(this).val(), 10),
				newAges    = [],
				i;

			hotelRooms[roomIdx].numChildren = childCount;

			if (childCount > 0) {
				for (i = 0; i < childCount; i++) {
					newAges[i] = hotelRooms[roomIdx].childrenAges[i];
					if (newAges[i] === '' || newAges[i] === undefined) {
						newAges[i] = 0;
					} else {
						newAges[i] = parseInt(newAges[i], 10);
					}
				}
			}

			hotelRooms[roomIdx].childrenAges = newAges;
			buildRoomConfigUI();
			updateHotelRoomDisplay($form);
			serializeHotelRooms($form);
		});

		$(document).on('change', '.searchbar-hotel-child-age', function childAgeChange() {
			var roomIdx  = $(this).data('room'),
				childIdx = $(this).data('child');

			hotelRooms[roomIdx].childrenAges[childIdx] = parseInt($(this).val(), 10);
			serializeHotelRooms($form);
		});

		$(document).on('click', '.searchbar-hotel-room-config-done', function doneConfig() {
			serializeHotelRooms($form);
			$('#searchbarHotelRoomModal').modal('hide');
		});
	}

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	function submitHotelSearch($form) {
		var $locationWrap = $form.find('span.options[data-type="hotel"] .google-places').first(),
			lat           = $locationWrap.find('input.lat').val(),
			lng           = $locationWrap.find('input.lng').val(),
			placeId       = $form.find('input[name*="place_id"]').val(),
			checkIn       = normalizeHotelDateValue($form, 'searchbar-checkin'),
			checkOut      = normalizeHotelDateValue($form, 'searchbar-checkout'),
			radius        = $form.find('#searchbar-location_radius').val(),
			locationSearch = $locationWrap.find('input[type="text"]').val(),
			criteria, location, structuredRooms, formData, coordinates;

		serializeHotelRooms($form);

		if (!placeId && (!lat || !lng)) {
			alert('Please select a location from the dropdown suggestions.');
			return false;
		}

		if (!checkIn || !checkOut) {
			alert('Please enter check-in and check-out dates.');
			return false;
		}

		if (new Date(checkOut) <= new Date(checkIn)) {
			alert('Check-out must be after check-in.');
			return false;
		}

		structuredRooms = hotelRooms.map(function mapRoom(room) {
			return {
				num_adults  : String(room.numAdults),
				num_children: String(room.numChildren),
				child_ages  : (room.childrenAges || []).map(function mapAge(age) {
					return String(age);
				})
			};
		});

		criteria = {
			check_in : checkIn,
			check_out: checkOut,
			rooms    : structuredRooms
		};

		location = {
			radius: parseInt(radius, 10) || 20
		};

		if (lat && lng) {
			location.lat = parseFloat(lat);
			location.lng = parseFloat(lng);
		}

		if (placeId) {
			location.place_id = placeId;
		}

		formData = {
			locationSearch: locationSearch,
			locationRadius: parseInt(radius, 10) || 20,
			checkIn       : checkIn,
			checkOut      : checkOut,
			numRooms      : hotelRooms.length,
			rooms         : hotelRooms.map(function mapFormRoom(room, index) {
				return {
					roomNumber  : index + 1,
					numAdults   : room.numAdults,
					numChildren : room.numChildren,
					childrenAges: room.childrenAges || []
				};
			})
		};

		coordinates = {
			lat: location.lat,
			lng: location.lng
		};

		if (placeId) {
			coordinates.place_id = placeId;
		}

		sessionStorage.removeItem('selectedHotel');
		sessionStorage.removeItem('selectedRoom');
		sessionStorage.removeItem('rate_select_string');
		sessionStorage.setItem('formData', JSON.stringify(formData));
		sessionStorage.setItem('coordinates', JSON.stringify(coordinates));
		sessionStorage.setItem('searchCriteria', JSON.stringify(criteria));
		sessionStorage.setItem('searchLocation', JSON.stringify(location));
		sessionStorage.setItem('locationSearch', JSON.stringify(locationSearch));

		window.location.href = Adzuki.base_uri
			+ '/HotelSearch/searchResults/'
			+ encodeUrlParam(criteria) + '/'
			+ encodeUrlParam(location);
	}

	form.load = function load($form)
	{
		var countRequest = null;

		initHotelRoomsFromForm($form);
		initHotelRoomModal($form);
		initHotelDatePickerIcons($form);
		ensureCheckoutAfterCheckIn($form);

		toggleAdvancedSearchButton($form.find('select#searchbar-type').val());

		if ($form.find('select#searchbar-type').val() === 'hotel') {
			$('.date-search').addClass('hidden');
		}

		$("#searchbar-tour_destination").on('keyup', function checkForDestination() {
			if ($("#searchbar-tour_destination").val().trim().length <= 1) {
				$form.find('#searchbar-tour_city_id').val('');
				$form.find('.tour-country-id').val('');
			} else if ($('#searchbar-tour_city_id').val().trim() === '' && $('#searchbar-tour_country_id').val().trim() === '') {
				if (countRequest !== null) {
					countRequest.abort();
				}
			}
		});

		Adzuki.Typeahead(
			'.tour-location-search',
			'/TourSearch/locations',
			function select(item) {
				$form.find('.tour-city-id').val(item.city_id);
				$form.find('.tour-country-id').val(item.country_id);
			}
		);

		$form.find('select#searchbar-type').on('change', function changeType() {
			var $submit_btn = $form.find('[type="submit"]');

			$('.date-search').removeClass('hidden');

			if (this.value === 'package') {
				getDestinationList();
				getCruiseLineList(this.value);
			} else if (this.value === 'cruise') {
				getCruiseLineList(this.value);
			} else if (this.value === 'hotel') {
				$('.date-search').addClass('hidden');
				$submit_btn.prop('disabled', false).html('Search');
			}

			$form.find('span.options').addClass('hidden');
			$form.find('span.options[data-type="'+this.value+'"]').removeClass('hidden');

			if (this.value === 'cruise' || this.value === 'package') {
				$form.find('span.options.cruise-fields').removeClass('hidden');
			} else {
				$form.find('span.options.cruise-fields').addClass('hidden');
			}

			toggleAdvancedSearchButton(this.value);
		});

		$form.find('select.cruise-line').change(function cruiseLineChanged()
		{
			var $self        = $(this),
			    $this_form   = $self.parents('form'),
			    $ship_select = $this_form.find('select.ship'),
			    ship_data    = [],
			    sorted_data  = [],
			    search_path  = '/CruiseSearch/getShips/';

			if ($this_form.find('select#searchbar-type').val() === 'package') {
				search_path = '/Packages/getPackageShipList/';
			}

			Adzuki.Ajax.get(search_path + $self.val())
			.then(function populateShipSelect(data) {
				$ship_select.empty();
				ship_data.push($('<option>').text('Any Ship').attr('value', ''));

				sorted_data = Adzuki.Sort.alphabeticValue(data);
				$.each(sorted_data, function appendShipOption(sKey, sValue) {
					ship_data.push($('<option>').text(sValue.value).attr('value', sValue.key));
				});

				$ship_select.append(ship_data);
			});
		});

		$form.on('change dp.change', Adzuki.Debounce(function updateItineraryCount() {
			var $self        = $(this),
			    $submit_btn  = $self.find('[type="submit"]'),
			    record_count = 0,
			    count_url    = '/CruiseSearch/getCount',
				search_type  = 'cruise',
				selectedType = $self.find('select#searchbar-type').val();

			if (selectedType === 'hotel') {
				$submit_btn.prop('disabled', false).html('Search');
				return;
			}

			if (selectedType !== undefined) {
				if (selectedType === 'tour') {
					search_type = 'tour';
					count_url   = '/TourSearch/countResults';
				}

				if (selectedType === 'package') {
					search_type = 'package';
					count_url   = '/Packages/countResults';
				}

				$submit_btn
					.prop('disabled', true)
					.html('Searching...');

				countRequest = Adzuki.Ajax.post(count_url, $self.serialize());
				countRequest.then(function changeSubmitButtonText(data)
				{
					if (search_type === 'cruise') {
						record_count = parseInt(data[0].dynamic.count);
					}
					else if (search_type === 'tour') {
						record_count = parseInt(data.matched.replace(',', ''));
					}
					else if (search_type === 'package') {
						record_count = parseInt(data.count);
					}

					if (record_count && record_count > 0) {
						record_count = accounting.format(record_count);
						$submit_btn
							.prop('disabled', false)
							.html('View Results (' + record_count + ')');
					}
					else {
						$submit_btn.html('No Results');
					}
				});
			}
		}, 500));

		$form.find('button.btn-primary').on('click', function submitClicked(e)
		{
			if ($form.find('select#searchbar-type').val() === 'hotel') {
				e.preventDefault();
				submitHotelSearch($form);
				return false;
			}

			$(this).html('<i class="' + Adzuki.FaIcon.getIconStyle('cog') + ' fa-spin fa-fw"></i> Getting results...');
		});

		$('#cruisesearchfilter-ships').change(function filterShipsChanged()
		{
			$('#cruisesearchfilter-destinations').selectpicker('selectAll');
		});

		$('#cruisesearchfilter-destinations').change(function filterShipsChanged()
		{
			$('#cruisesearchfilter-departure_ports').selectpicker('selectAll');
		});

		$('#cruisesearchfilter-departure_ports').change(function filterShipsChanged()
		{
			$('#cruisesearchfilter-arrival_ports').selectpicker('selectAll');
		});

		(function initGooglePlaces() {
			var $container = $form.find('span.options[data-type="hotel"] .google-places');

			if ($container.length && $container.find('input[type="text"]').length) {
				Adzuki.GooglePlaces($container);

				$container.find('input[type="text"]').on('gp.selected', function onPlaceSelected(e, item) {
					if (item && item.place_id) {
						$form.find('input[name*="place_id"]').val(item.place_id);
					}
				});
			}
		}());

		$form.find('.searchbar-hotel-date#searchbar-checkin').on('change', function checkInChange() {
			ensureCheckoutAfterCheckIn($form);
		});

		$form.find('.searchbar-hotel-date#searchbar-checkout').on('change', function checkOutChange() {
			ensureCheckoutAfterCheckIn($form);
		});

		function getCruiseLineList(type)
		{
			var $cruise_line_select = $form.find('select#searchbar-bottom_cruise_lines'),
			    cruise_line_data    = [],
			    sorted_data         = [],
			    search_path         = '/CruiseSearch/getCruiseLinesForWebsite/';

			if (type === 'package') {
				search_path = '/Packages/getPackageCruiseLineList/';
			}

			Adzuki.Ajax.get(search_path)
			.then(function populateCruiseLineSelect(data) {
				$cruise_line_select.empty();
				cruise_line_data.push($('<option>').text('Any Cruise Line').attr('value', ''));

				if (type === 'package') {
					sorted_data = Adzuki.Sort.alphabeticValue(data);

					$.each(sorted_data, function appendCruiseLines(sKey, sValue) {
						cruise_line_data.push($('<option>').text(sValue.value).attr('value', sValue.key));
					});
				} else {
					$.each(data, function parseCruiseLines(oKey, oValues) {
						var $optgroup        = $('<optgroup label="' + oKey + '">'),
						    cruise_line_list = Adzuki.Sort.alphabeticValue(oValues);

						$.each(cruise_line_list, function appendCruiseLines(sKey, sValue) {
							$optgroup.append($('<option>').text(sValue.value).attr('value', sValue.key));
						});

						cruise_line_data.push($optgroup);
					});
				}

				$cruise_line_select.append(cruise_line_data);
			});
		}

		function getDestinationList()
		{
			var $destination_select = $form.find('select.destination'),
			    destination_data    = [],
			    sorted_data         = [];

			Adzuki.Ajax.get('/Packages/getPackageDestinationList')
			.then(function populateDestinationSelect(data) {
				$destination_select.empty();
				destination_data.push($('<option>').text('Any Destination').attr('value', ''));

				sorted_data = Adzuki.Sort.alphabeticValue(data);
				$.each(sorted_data, function appendDestinationOption(sKey, sValue) {
					destination_data.push($('<option>').text(sValue.value).attr('value', sValue.key));
				});

				$destination_select.append(destination_data);
			});
		}

		function toggleAdvancedSearchButton(search_type)
		{
			var advanced_button = $('aside#search .btn-advanced');

			if (search_type === 'cruise') {
				advanced_button.removeClass('hidden');

				advanced_button.off('click').on('click', function advancedButton(e) {
					e.preventDefault();
					window.location.href = Adzuki.base_uri + '/CruiseSearch/AdvancedSearch/1';
				});
			} else {
				advanced_button.addClass('hidden');
			}
		}
	};

}(jQuery, window.Adzuki || {}));
